const r = ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp", "Object", "Error", "Symbol"];
r.reduce((o, e) => ({
  ...o,
  [`[object ${e}]`]: e.toLowerCase()
}), {});
